import React from "react";
import Card from "react-bootstrap/Card";
import "../../style.css";
import "bootstrap/dist/css/bootstrap.min.css";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
          Software Engineer who is capable of writing efficient code using current best practices in <span className="purple"> Mobile App/Web development </span> also who is proficient in array of programming languages and software tools, with exceptional level of versatility gained in using new tools and technical developments to drive improvements throughout entire software development life cycle, having an artistic mind, experience of group work along with exceptional analytical design and problem solving capabilities. I aspire to work in good teams, polish my technical skills, learn new technologies and invent amazing things.
            <br />
            <br />
            {/* Apart from coding, some other activities that I love to do! */}
          </p>
          {/* <ul>
            <li className="about-activity">
              <i className="far fa-hand-point-right"></i> Playing Games
            </li>
            <li className="about-activity">
              <i className="far fa-hand-point-right"></i> Writting Tech Blogs
            </li>
            <li className="about-activity">
              <i className="far fa-hand-point-right"></i> Travelling
            </li>
          </ul> */}

          <p style={{ marginBlockEnd: 0, color: "rgb(155 126 172)"}}>
            "Talk is cheap. Show me the code."{" "}
          </p>
          <footer className="blockquote-footer">Linus Torvalds</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
